import React from 'react';
import { Box, Pagination, FormControl, Select, MenuItem, Typography, Grid } from '@mui/material';

const PaginationComponent = ({
  currentPage,
  totalPages,
  totalCount,
  limit,
  onPageChange,
  onLimitChange,
  showLimitSelector = true,
}) => {
  const handlePageChange = (event, value) => {
    onPageChange(value);
  };

  const handleLimitChange = (event) => {
    onLimitChange(event.target.value);
  };

  const startItem = (currentPage - 1) * limit + 1;
  const endItem = Math.min(currentPage * limit, totalCount);

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Grid container spacing={2} alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography variant="body2" color="text.secondary">
            Showing {startItem} to {endItem} of {totalCount} entries
          </Typography>
        </Grid>

        <Grid item>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {showLimitSelector && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2">Show:</Typography>
                <FormControl size="small" sx={{ minWidth: 80 }}>
                  <Select value={limit} onChange={handleLimitChange} displayEmpty>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                    {/* {totalCount > 0 && <MenuItem value={totalCount}>All ({totalCount})</MenuItem>} */}
                  </Select>
                </FormControl>
                <Typography variant="body2">entries</Typography>
              </Box>
            )}

            {/* <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              // color="primary"
              size="medium"
              showFirstButton
              showLastButton
              sx={{ color: '#BD1D23' }}
            /> */}
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              // color="primary"
              size="medium"
              shape="square"
              showFirstButton
              showLastButton
              sx={{
                '& .MuiPaginationItem-root.Mui-selected': {
                  backgroundColor: '#BD1D23',
                  color: 'white',
                  borderRadius: '4px',
                },
                '& .MuiPaginationItem-root': {
                  color: 'black',
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: '#9C27B0',
                    color: 'white',
                  },
                },
                '& .MuiPaginationItem-root.MuiPaginationItem-page': {
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: '#9C27B0',
                    color: 'white',
                  },
                },
                '& .MuiPaginationItem-root.MuiPaginationItem-ellipsis': {
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: '#9C27B0',
                    color: 'white',
                  },
                },
                '& .MuiPaginationItem-root.MuiPaginationItem-firstLast': {
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: '#9C27B0',
                    color: 'white',
                  },
                },
                '& .MuiPaginationItem-root.MuiPaginationItem-previousNext': {
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: '#9C27B0',
                    color: 'white',
                  },
                },
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaginationComponent;
